function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "m362.667969 298.667969h-48c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h48c64.703125 0 117.332031-52.652344 117.332031-117.335938 0-64.679687-52.628906-117.332031-117.332031-117.332031h-48c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h48c82.34375 0 149.332031 67.007812 149.332031 149.332031 0 82.328125-66.988281 149.335938-149.332031 149.335938zm0 0"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "m197.332031 298.667969h-48c-82.34375 0-149.332031-67.007813-149.332031-149.335938 0-82.324219 66.988281-149.332031 149.332031-149.332031h48c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16h-48c-64.703125 0-117.332031 52.652344-117.332031 117.332031 0 64.683594 52.628906 117.335938 117.332031 117.335938h48c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "m325.332031 165.332031h-138.664062c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h138.664062c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0"
});

var SvgUrl = function SvgUrl(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 -107 512 512",
    width: "512pt",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUrl, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/url.354e487f.svg";
export { ForwardRef as ReactComponent };